import { render, staticRenderFns } from "./ProgressBox.vue?vue&type=template&id=0bba0a94&scoped=true"
import script from "./ProgressBox.vue?vue&type=script&lang=js"
export * from "./ProgressBox.vue?vue&type=script&lang=js"
import style0 from "./ProgressBox.vue?vue&type=style&index=0&id=0bba0a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba0a94",
  null
  
)

export default component.exports